<template>
    <div class="custom-node" :class="{ 'node-selected': isSelected }">
        <div class="node-holder display-flex align-items-center w-100">
            <img class="type-icon mr-xs" :src="computedImage" alt="node" />
            <div class="text-holder display-flex flex-wrap w-100">
                <p class="node-type text-xs font-bold text-stone-800 w-100">{{ data.nodeType }}</p>
                <p
                    v-tooltip="{
                        content: data.name,
                    }"
                    class="node-type text-sm text-stone-800 text-truncate"
                >
                    {{ data.name }}
                </p>
            </div>
        </div>
        <Handle type="target" :position="Position.Left" style="opacity: 0; pointer-events: none" />
        <Handle type="source" :position="Position.Right" style="opacity: 0; pointer-events: none" />
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { Handle, Position } from '@vue-flow/core'
import { useArenaStore } from '@/stores'

const props = defineProps(['data', 'position'])
const arenaStore = useArenaStore()

const computedImage = computed(() => {
    const type = props.data.nodeType === 'product' ? 'concept' : props.data.nodeType
    return new URL(`/src/assets/img/arenaBoard/${type}.png`, import.meta.url)
})

const isSelected = computed(() => {
    if (!arenaStore.selectedNode) return false
    return arenaStore.selectedNode.id === props.data?.id
})
</script>

<style lang="scss" scoped>
.custom-node {
    outline: 1px solid var(--color-moat-600);
    padding: 10px;
    width: 250px;
    border-radius: 5px;
    background: #fff;
    cursor: pointer;

    transition: all 0.1s ease-in-out;

    &.node-selected {
        outline: 3px solid var(--color-moat-600);
    }

    .type-icon {
        width: 35px;
        height: 35px;
    }

    .node-type {
        text-transform: capitalize;
    }

    .text-holder {
        flex: 1;
        min-width: 0;
    }
}
</style>
